import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiCheck } from 'react-icons/fi'
import { HiOutlineLink } from 'react-icons/hi2'

import Modal from '../../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../../utils/api'

import EditCost from '../EditCost'
import ApplyCostToColors from '../ApplyCostToColors'
import NumberToMoney from '../../../../shared/functions/NumberToMoney'

/* Hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage'

import '../../../../shared/css/costItem.css'

function ListCostRow({ dataArray, providerId, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess, selectItem, handleOnSelectItem, selectedData }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditCost, setModalEditCost] = useState(false)
    const [costId, setCostId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [deleteName, setDeleteName] = useState("")
    const [selectedItens, setSelectedItens] = useState(selectedData || [])
    const [modalApplyCost, setModalApplyCost] = useState(false)
    const [applyCostItem, setApplyCostItem] = useState(null)

    async function deleteCost(id) {
        let msgType = 'success'
        const data = await api.delete(`/cost/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    const isSelected = (item) => !!selectedItens.find((i) => i._id === item._id)

    const select = (item) => {
        const next = isSelected(item)
            ? selectedItens.filter((i) => i._id !== item._id)
            : [...selectedItens, item]
        setSelectedItens(next)
        handleOnSelectItem(next)
    }

    const costColumns = (item) => (
        <div className='cost-item-columns'>
            <span className='cost-item-description'>{item.description || '—'}</span>
            <span className='cost-item-range'>Entre {item.minUnit} e {item.maxUnit} unidades</span>
            <span className='cost-item-value'>R$ {NumberToMoney(item.cost)}</span>
        </div>
    )

    /* ------------------------ linhas ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                selectItem ? (
                    <div key={item._id} className={`pg-item pg-item-selectable ${isSelected(item) ? 'pg-item-selected' : ''}`} onClick={() => select(item)}>
                        <div className='pg-item-main'>
                            {costColumns(item)}
                        </div>
                        <div className={`pg-item-checkbox ${isSelected(item) ? 'pg-item-checkbox-checked' : ''}`}>
                            <FiCheck size={14} />
                        </div>
                    </div>
                ) : (
                    <div key={item._id} className='pg-item'>
                        <div className='pg-item-main'>
                            {costColumns(item)}
                        </div>

                        <div className='shd-row-box-item-action'>
                            {myPermissionEdit &&
                                <HiOutlineLink className='shd-icon-row-link' title='Aplicar a cores' onClick={() => { setApplyCostItem(item); setModalApplyCost(true) }} />
                            }
                            {myPermissionEdit &&
                                <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setCostId(item._id); setModalEditCost(true) }} />
                            }
                            {myPermissionDelete &&
                                <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setCostId(item._id); setDeleteName(item.description || `Entre ${item.minUnit} e ${item.maxUnit} unidades`) }} />
                            }
                        </div>
                    </div>
                )
            ))
        }
    }

    return (
        <div>
            {listArray()}

            {!selectItem && (
                <>
                    <Modal
                        modalStatus={modalEditCost}
                        changeStatus={setModalEditCost}
                        w={92}
                        t={3}
                        h={90}
                        content={
                            <EditCost id={costId} handleOnSuccess={() => { setModalEditCost(false); handleOnSuccess() }} btCancelAction={() => setModalEditCost(false)} />
                        }
                    />

                    <ConfirmDeleteModal
                        modalStatus={modalDeleteItem}
                        changeStatus={setModalDeleteItem}
                        onConfirm={() => deleteCost(costId)}
                        message="Deseja realmente excluir esse custo por unidade?"
                        itemName={deleteName}
                    />

                    <Modal
                        modalStatus={modalApplyCost}
                        changeStatus={setModalApplyCost}
                        w={92}
                        t={3}
                        h={90}
                        content={
                            applyCostItem &&
                            <ApplyCostToColors cost={applyCostItem} providerId={providerId} btCancelAction={() => setModalApplyCost(false)} handleOnSuccess={() => setModalApplyCost(false)} />
                        }
                    />
                </>
            )}
        </div>
    )
}

export default ListCostRow
